<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">广播节目管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="节目名称">
            <el-input
              v-model="showName"
              placeholder="请输入节目名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布状态">
            <el-select v-model="publishStatus" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in publishStatueArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="showName"
                label="节目名称"
              ></el-table-column>
              <el-table-column prop="showTypeTranslated" label="节目类型">
                <!-- <template slot-scope="scope">
                  <span v-if="scope.row.ItemType == 1">广播词</span>
                  <span v-else-if="scope.row.ItemType == 2">MP3</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="publishStatusTranslated" label="发布状态">
                <!-- <template slot-scope="scope">
                  <span v-if="scope.row.IsPublished == 1">已发布</span>
                  <span v-else>未发布</span>
                </template> -->
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import { BroadcastShowList, delBroadcastShow } from "@/api/src/broadcast";
export default {
  name: "BroadcastProgramView",
  controller: "UI",
  action: "BroadcastProgramView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      showName: null,
      publishStatus: "",
      publishStatueArr: [
        { value: 1, label: "已发布" },
        { value: 0, label: "未发布" },
      ],
      loading: false,
      loadingText: "",
    };
  },
  created: function() {},
  mounted: function() {
    this.search();
    // this.logInfo.ActionName = "广播节目查询";
    // this.logInfo.LogMessage = "广播节目查询";
    // this.logInfo.ModuleName = "广播系统";
    // this.logInfo.PageName = "节目管理列表";
    // this.addOperationLog();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadingText = "加载中...";
      const searchInfo = {
        showName: this.showName,
        publishStatus: this.publishStatus === "" ? null : this.publishStatus,
        PageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      BroadcastShowList(searchInfo).then(res=>{
        this.loading = false;
        if(res.code==200){
          this.tableData = res.rows;
          this.total = res.total;
        }else{
          this.tableData = [];
          this.total = 0;
          this.errmsg("服务异常，请联系管理员！");
        }
      })
      // new MyApis.ProgramApi()
      //   .GetPageContentByConditions(searchInfo)
      //   .then((r) => {
      //     r = r.data.Data;
      //     this.tableData = r.PageContents;
      //     this.total = r.BaseSearch.TotalCount;
      //     this.loading = false;
      //   })
      //   .catch((e) => {
      //     this.loading = false;
      //     console.log(e);
      //     this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
      //   });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/broadcast/UI/BroadcastProgramInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/BroadcastProgramInfo",
        query: { InfoId: row.id, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/broadcast/ui/BroadcastProgramInfo",
        query: { InfoId: row.id, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delBroadcastShow({ id: row.id }).then(res=>{
            if(res.code==200){
              this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.search();
            }else{
              this.$message({
                  type: "error",
                  message: "删除失败!",
                });
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.showName = null;
      this.publishStatus = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
